<div class="confirm-dialog__title-wrapper">
  <h2 mat-dialog-title data-cy="confirm-dialog-title">{{ title }}</h2>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content>
  <p
    class="confirm-dialog__content"
    [ngClass]="{ 'has-checkbox': checkboxMessage?.show }"
    [innerHTML]="message"
    data-cy="confirm-dialog-description"
  ></p>

  <div fxLayout="row" fxLayoutAlign="start" *ngIf="inputLabel">
    <mat-form-field class="mt-10" fxFlex="100" appearance="legacy">
      <mat-label>{{ inputLabel }}</mat-label>
      <textarea
        data-cy="confirm-dialog-textarea"
        autocomplete="off"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="5"
        [(ngModel)]="inputValue"
        [minlength]="inputRequired ? 5 : 0"
        [required]="inputRequired"
        #input="ngModel"
      ></textarea>
      <mat-error *ngIf="input.invalid">
        {{ (input.errors.required ? 'FIELD_REQUIRED_ERROR' : 'FIELD_MIN_LENGTH_ERROR') | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="checkboxMessage?.show" class="confirm-dialog__checkbox">
    <mat-checkbox [(ngModel)]="checked">{{ checkboxMessage?.message }}</mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
  <button
    color="primary"
    mat-stroked-button
    data-cy="confirm-dialog-confirm-button"
    [disabled]="inputRequired && !inputValue"
    (click)="confirm()"
  >
    <span> {{ okText || 'CONFIRMAR' }} </span>
  </button>

  <button
    class="field-background"
    color="primary"
    mat-flat-button
    mat-dialog-close
    (click)="cancel()"
    cdkFocusInitial
    data-cy="confirm-dialog-cancel-button"
  >
    <span> {{ cancelText || 'CANCELAR' }} </span>
  </button>
</mat-dialog-actions>
